import CTree from './components/Tree.vue'
import CTreeNode from './components/TreeNode.vue'
import CTreeSearch from './components/TreeSearch.vue'
import CTreeDrop from './components/TreeDrop.vue'
import './styles/index.less'

export default CTree

export {
  CTreeNode,
  CTreeSearch,
  CTreeDrop,
}
